export enum StoreType {
    GridFS = 'GridFS:Uploads',
    AmazonS3 = 'AmazonS3',
    GoogleCloudStorage = 'GoogleCloudStorage',
    Webdav = 'Webdav',
    FileSystem = 'FileSystem',
}
